// extracted by mini-css-extract-plugin
export var backButton = "_11-1";
export var content = "_11-d";
export var continueButton = "_11-7";
export var continueHint = "_11-8";
export var continueRow = "_11-6";
export var leftInner = "_11-0";
export var shell = "_11-e";
export var sidebarContent = "_11-5";
export var skipButton = "_11-c";
export var spacer = "_11-2";
export var spin = "_11-a";
export var spinner = "_11-9";
export var spinnerOverlay = "_11-b";
export var subtitle = "_11-4";
export var title = "_11-3";